export const SHIPMENT_PERMISSIONS = {
    MILESTONE_LIST: "MILESTONE_LIST",
    ADD_MILESTONE: "ADD_MILESTONE",
    ADD_COMMENT: "ADD_COMMENT",
    READ_DOCUMENT: "READ_DOCUMENT"
};